module.exports = __webpack_public_path__ + "static/media/tasks-alt.de08fb4a.svg";